export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=c8a70580&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/SvgIcon/index.vue?vue&type=template&id=c8a70580&scoped=true&
// module id = null
// module chunks = 